<template>
    <div class="dorms">
        <div class="row">
            <div class="col-md-12">
                <div class="widget">
                    <div class="table-area">
                        <div class="widget-title">
                            <h3><i :class="icon"> </i> {{ tableName }}</h3>
                            <span>{{ tableDesc }}</span>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Başlık</th>
                                        <th>İşlemler</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in items" :key="item.id">
                                        <td>{{ item.title }}</td>
                                        <td>
                                            <router-link :to="{ name: 'pages.update', params: {id: item.id} }" class="btn btn-primary btn-xs"> <span>Düzenle</span></router-link> / <button class="btn btn-danger btn-xs" @click="destroy(item)" >  Sil</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/layouts/Pagination'
    export default {
        components: { Pagination },
        data () {
            return {
                tableName: 'Sayfalar Tablosu',
                icon: 'fa fa-columns',
                tableDesc: '',
                api: 'pages/',
                items: [],
                pagination: {
                    'current_page': 1
                },
            }
        },
        mounted () {
            this.getData()
        },
        methods: {
            getData() {
                this.axios.get(this.api).then(response => {
                    this.items = response.data
                })
            },
            destroy(item) {
                this.$swal({
                    title: 'Silmek istediğinizden emin misiniz?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Evet',
                    cancelButtonText: 'İptal'
                    }).then((result) => {
                        if(result.value) {
                            this.axios.delete(this.api + item.id).then(response => {
                                if (response.status == 200) {
                                    this.$swal(
                                        'Başarılı!',
                                        'Veri silme işlemi başarılı',
                                        'success'
                                    )
                                    this.items.splice(this.items.indexOf(item), 1)
                                }
                            })
                        }
                    })
            }
        },
    }
</script>

<style scoped>

</style>